<template>
    <section class="combo-block"
             :class="{ 'mobile-style' : !isDesktop, 'has-block-shadow' : hasBlockShadow, 'skeleton-box' : !blockLoaded && !productsReady, 'combo-can-zoom' : isVisible}"
             :id="elementId"
             @mouseover="zoomed = true"
             @mouseleave="zoomed = false"
             v-observe-visibility="{
                callback: visibilityChanged,
                intersection: {
                    threshold: 0.7,
                },
            }"
    >
        <Mub :blockComboData="comboData">
            <div class="combo-container" @click="setModal(true)">
                <div class="click-layer"><i class="layer-icon ecom-plus"/></div>
                <div class="media d-flex">
                    <BlockImage v-if="firstProductData" :classNames="'w-100'" :classNamesBox="'w-50 h-100'" :image="firstProductData.imageNewIn" :title="firstProductData.name" :webpAllowed="true"></BlockImage>
                    <BlockImage v-if="secondProductData" :classNames="'w-100'" :classNamesBox="'w-50 h-100'" :image="secondProductData.imageNewIn" :title="secondProductData.name" :webpAllowed="true"></BlockImage>
                </div>
                <ul v-show="!isDesktop || zoomed" class="item-list">
                    <li v-if="firstProductData"> <span class="list-decoration"/> {{ firstProductData.name }} </li>
                    <li v-if="secondProductData"> <span class="list-decoration"/> {{ secondProductData.name }} </li>
                </ul>
                <div v-if="price" class="price-container">
                    <p v-if="priceCrossed" class="price crossed"> {{ priceCrossed }} </p>
                    <p class="price"> {{ price }} </p>
                </div>
                <span v-if="discountLabel" class="combo-label">  
                    <i class="icon-promo-code"/>
                    {{ discountLabel }} 
                </span>
            </div>
        </Mub>    
    </section>
</template>

<script>
import BlockImage from '@/components/Home/Common/Partials/BlockImage.vue';
//import ComboCart from '@/components/ComboCart/ComboCart';
import CartNotification from '@/components/AddToCart/partials/notifications/CartNotification';
//import BlockShadow from '@/components/Home/Desktop/Blocks/Partials/BlockShadow';
import Mub from '@/components/Mub';

import {storeCombos} from '@/store/comboCart';
import utilities from '@/Utilities/common';

export default {
    storeCombos,
    name: 'ComboHomeBlock',
    components: {
        //ComboCart,
        CartNotification,
        Mub,
        BlockImage
        /*BlockShadow*/
    },
    props: {
        index: {type: Number, default: 0},
        hasBlockShadow: {type: Boolean, default: false},
        blockLoaded: {type: Boolean, default: false},
        //zoomed: {type: Boolean, default: false},
        isDesktop: {type: Boolean, default: true},
        comboData: {type: Object, default: {}},
        //forceShow: {type: Boolean, default: false},
    },
    data() {
        return {
            zoomed: false,
            isVisible: false
        };
    },
    computed: {
        elementId() {
            return 'comboId' + '-' +  this.comboId;
        },
        kStrings() { // merge with  combokstrings object?
            return storeCombos.getters.kStrings;
        },
        comboKStrings() {
            return storeCombos.getters.comboKStrings; // same for all
        },
        /*cartNotification() {
            /!*return {
                link: '',
                success: true,
                animationState: null,
                message: 'allo its test!',
                actionText: '',
            };*!/
            
            return storeCombos.getters.cartNotification;
        },*/
        productsReady() {
            return this.firstProductData && this.secondProductData;
        },
        itemList() {
            //let productsReady = this.firstProductData && this.secondProductData;
            return this.productsReady ? {
                firstProductName: this.firstProductData.name,
                secondProductName: this.secondProductData.name
            } : null
        },
        price() {
            //let productsReady = this.firstProductData && this.secondProductData;
            let price = this.productsReady ? App.js.formatPrice(this.firstProductData.price + this.secondProductData.price) : null;
            
            return price ? price : null;
        },
        priceCrossed() {
            let priceCrossed = this.price ? App.js.formatPrice(this.firstProductData.priceReference + this.secondProductData.priceReference) : null;
            return priceCrossed ? priceCrossed : null;
        },
        comboId() {
            return this.comboData.comboId;
        },
        couponId() {
            return storeCombos.getters.couponId[this.comboId];
        },
        discount() {
            return storeCombos.getters.discount[this.comboId];
        },
        discountLabel() {
            return storeCombos.getters.discountLabel[this.comboId];
        },
        comboModal() {
            /*if(storeCombos.getters.showComboModal[this.comboId]) {
                utilities.disableBodyScroll()
            } else  {
                utilities.enableBodyScroll()
            }*/

            return storeCombos.getters.showComboModal[this.comboId];
        },
        firstProductData() {
            const data = storeCombos.getters.productsData;
            return data && data[this.comboId] ? data[this.comboId][0] : null;
        },
        secondProductData() {
            const data = storeCombos.getters.productsData;
            return data && data[this.comboId] ? data[this.comboId][1] : null;
        }
    },
    watch: {
        comboModal(value) {
            /*if(value) {
                utilities.disableBodyScroll();
            } else {
                utilities.enableBodyScroll();
            }*/
            if(!this.isDesktop) {
                utilities.eventModalApp(value);
            }
        },
        price(value) {
            if(value) {
                let priceData = {
                    price: this.price,
                    priceCrossed: this.priceCrossed
                }

                storeCombos.dispatch('setPriceData', {[this.comboId]: priceData});
            }
        },
    },
    beforeCreate() {
    },
    mounted() {
        // TEST MODE
        this.$nextTick(function() {
            storeCombos.dispatch('addCombo', this.comboData);
        });
    },
    methods: {
        setModal(status) {
            if (!this.isDesktop || !this.isVisible) {
                //console.log('EMIT!');
                this.$emit('open-combo-modal', this.comboId)
            } else {
                storeCombos.dispatch('setComboModal', {[this.comboId]: status});
            }
        },
        resetNotification() {
            storeCombos.dispatch('setCartNotification', null);
        },
        eventModalApp: function(value){
            if(typeof App !== 'undefined'){
                App.js.callAppsJs('evtModal', value);
            }
        },
        visibilityChanged(isVisible) {
            this.isVisible = isVisible;
        },
    },
};
</script>

<style scoped>

</style>